import { getHeaderValue, type RequestWithHeaders } from './request-extractor';

/**
 * Header stamped onto requests from QA automation browsers.
 */
export const AUTOMATION_PLATFORM_HEADER = 'user-automation-platform';

/**
 * Accepted header values, pre-lowercased for case-insensitive comparison. CBSVIDEO-9244
 * rolled the QA side over to the Paramount value; the ViacomCBS value stays as a
 * transition safety net for automation nodes that lag that rollout.
 */
export const AUTOMATION_PLATFORM_VALUES = [
    'paramount quality engineering',
    'viacomcbs quality engineering',
];

/**
 * True when the request originates from QA/Synergy automation. The proxy stamps the
 * header onto every request from an automation browser (not just the initial page load
 * — see Confluence "mqe-pplus-tests Repo Overview"), so checking it here mirrors
 * legacy's per-test "Synergy automation-header check" gate.
 */
export const isAutomationRequest = (req: RequestWithHeaders): boolean => {
    const headerValue = (getHeaderValue(req, AUTOMATION_PLATFORM_HEADER) ?? '')
        .trim()
        .toLowerCase();

    // When a header is sent as an array, getHeaderValue joins them with ", "
    // We only need to check the first value.
    const firstValue = headerValue.split(',')[0].trim();
    return AUTOMATION_PLATFORM_VALUES.includes(firstValue);
};
